import { useState, FormEvent } from 'react';
import { useRequestPasswordReset, AuthError , PasswordResetRequestForm  } from '@auth';

interface PasswordResetRequestPageProps {
  onBackToSignIn: () => void;
}

export default function PasswordResetRequestPage({ onBackToSignIn }: PasswordResetRequestPageProps) {
  const requestPasswordReset = useRequestPasswordReset();
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsSuccess(false);

    try {
      await requestPasswordReset.mutateAsync({ email });
      setIsSuccess(true);
    } catch (error_) {
      const authError = error_ as AuthError;
      setError(authError.error ?? 'Password reset request failed');
    }
  };

  return (
    <PasswordResetRequestForm
      email={email}
      error={error}
      isLoading={requestPasswordReset.isPending}
      isSuccess={isSuccess}
      onEmailChange={setEmail}
      onSubmit={handleSubmit}
      onBackToSignIn={onBackToSignIn}
    />
  );
}
